"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CommonTabs = exports.CommonRoleTab = void 0;

var _commonTabs = _interopRequireDefault(require("./components/common-tabs"));

exports.CommonTabs = _commonTabs["default"];

var _paymentTabs = _interopRequireDefault(require("./components/payment-tabs"));

exports.CommonRoleTab = _paymentTabs["default"];